import React from 'react'
import "./Profile.css"
import Common_breadcrumb from '../common_components/common-breadcrumb/Common_breadcrumb';
import Tab_holder from './tab_holder/Tab_holder';
import Tab_content_holder from './tab_content_holder/Tab_content_holder';
import { Tab } from 'react-bootstrap';

function Profile() {
    const breadcrumbsData = [
        { name: "HOMEPAGE", href: "/" },
        { name: "Profile", active: true }
    ];
    return (
        <>
            <section className='Profile'>
                <Common_breadcrumb
                    pageName="Profile"
                    bgImage="/assets/images/Terms_and_condition/bg/bg.png"
                    breadcrumbs={breadcrumbsData}
                />


                <div className="Profile_tab_content_holder">
                    <div className="container">
                        <div className="Profile_tab_content">
                            <Tab.Container id="left-tabs-example" defaultActiveKey="Personal_Details">
                                <div className="row me-0 ms-0">
                                    <div className="col-md-4 p-0">
                                        <div className="tab_holder">
                                            <Tab_holder />
                                        </div>
                                    </div>
                                    <div className="col-md-8 p-0">
                                        <div className="tab_content_holder">
                                            <Tab_content_holder />
                                        </div>
                                    </div>
                                </div>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Profile